import React from 'react';
import { Svelte } from '../utils/SvelteToReact';
import { Button as ButtonSvelte } from '@glance-design/button';

export const Button = (props) => {
  const defineProps = {
    size: props.size,
    variant: props.variant,
    shape: props.shape,
    animation: props.animation || false,
    onClick: props.onClick,
    type: props.type,
    disabled: props.disabled || false,
    outline: props.outline || false,
    rtl: props.rtl || false,
    skeleton: props.skeleton || false,
    class: props.className || false
  };

  return (
    <Svelte component={ButtonSvelte} {...defineProps}>
      {props.children}
    </Svelte>
  );
};
